// extracted by mini-css-extract-plugin
module.exports = {"text":"textUnderlined_text__Il29p"};